import { useEffect, useState } from 'react';
import Navigation from './Navigation';
import MobileNavigation from './MobileNavigation';

const ResponsiveNavigation = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return isMobile ? <MobileNavigation /> : <Navigation />;
};

export default ResponsiveNavigation;
